import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import React from 'react'
import { useScreenSize } from '../../../sharedComponents/src/hooks/useScreenSize'

interface IProps {
    icon: React.ReactNode
    title: string
}

const PuzzleTitle: React.FC<IProps> = ({ icon, title }) => {
    const { isMobile } = useScreenSize()

    return (
        <Stack direction="row" gap={1} alignItems="center">
            <Box
                sx={{
                    display: 'inline-flex',
                    width: isMobile ? 24 : 32,
                    height: isMobile ? 24 : 32,
                    alignItems: 'center',
                    '& svg': { width: '100%', height: '100%', display: 'block' },
                }}
            >
                {icon}
            </Box>
            <Typography variant={isMobile ? 'h5' : 'h4'} textTransform="uppercase">
                {title}
            </Typography>
        </Stack>
    )
}

export default PuzzleTitle
